import { useCallback, useEffect, useState } from "react";

import {
  IRoadLoadService,
  NotificationHistory,
  NotificationMessage,
} from "@modules/roadLoad/model";

import { useIoCContext } from "@context/IoCContext/IoCContext";
import { Types } from "@ioc/types";

import useDialogAlert from "@hooks/useDialogAlert";
import AppError from "@utils/AppError";

export const useRoadLoadNotificationBell = () => {
  const { serviceContainer } = useIoCContext();
  const { snackbar } = useDialogAlert();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const [
    notificationHistory,
    setNotificationHistory,
  ] = useState<NotificationHistory | null>(null);

  const [
    selectedMessage,
    setSelectedMessage,
  ] = useState<NotificationMessage | null>(null);

  const [messageCount, setMessageCount] = useState<number | null>(null);

  const {
    RoadLoad: { IRoadLoadService },
  } = Types;
  const roadLoadService = serviceContainer.get<IRoadLoadService>(
    IRoadLoadService
  );

  const notificationAck = useCallback(
    async (id: string) => {
      await roadLoadService.notificationAck(id);
    },
    [roadLoadService]
  );

  useEffect(() => {
    const load = async () => {
      try {
        const { count } = await roadLoadService.notificationCount();
        setMessageCount(count);

        const history = await roadLoadService.notificationHistory();
        setNotificationHistory(history);
      } catch (err) {
        if (err instanceof AppError) {
          snackbar({
            message: `Erro ao carregar as Notificações - ${err.message}`,
            variant: "error",
          });
        }
      }
    };

    void load();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMessage]);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenModal = (message: NotificationMessage) => {
    setSelectedMessage(message);
    void notificationAck(message.id);
  };

  const handleCloseModal = () => {
    setSelectedMessage(null);
  };

  const hasNotification = !!notificationHistory?.rows?.length;

  return {
    state: {
      anchorEl,
      notificationHistory,
      selectedMessage,
      messageCount,
      hasNotification,
    },
    actions: {
      handleOpenMenu,
      handleCloseMenu,
      handleOpenModal,
      handleCloseModal,
    },
  };
};
